var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.953 1.98438C11.6826 1.98503 11.4149 2.03923 11.1656 2.14384C10.9162 2.24845 10.69 2.4014 10.5 2.59388L2.5935 10.4999L2.5625 10.6564L2.0155 13.4064L1.8595 14.1404L2.594 13.9844L5.344 13.4374L5.5 13.4059L13.4065 5.49988C13.5995 5.31024 13.7528 5.08406 13.8574 4.83455C13.962 4.58504 14.0159 4.31719 14.0159 4.04663C14.0159 3.77606 13.962 3.50821 13.8574 3.2587C13.7528 3.00919 13.5995 2.78301 13.4065 2.59337C13.2164 2.40093 12.9901 2.24803 12.7407 2.14351C12.4912 2.03898 12.2235 1.9849 11.953 1.98438V1.98438ZM11.953 2.93737C12.205 2.93737 12.459 3.05237 12.703 3.29687C13.1895 3.78287 13.1895 4.31038 12.703 4.79688L12.344 5.14038L10.859 3.65587L11.203 3.29687C11.4475 3.05237 11.701 2.93737 11.953 2.93737V2.93737ZM10.1565 4.35938L11.6405 5.84387L5.594 11.8899C5.26757 11.2512 4.74788 10.7319 4.109 10.4059L10.1565 4.35938ZM3.469 11.2189C3.76492 11.3379 4.03372 11.5156 4.25927 11.7411C4.48481 11.9667 4.66245 12.2355 4.7815 12.5314L3.1405 12.8594L3.469 11.2189Z",
    fill: "black",
    fillOpacity: 0.6
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.6c5a1a5a.svg";
export { ForwardRef as ReactComponent };